import React, { useEffect, useState } from "react";
import { Box, Grid2, Stack, Typography } from "@mui/material";
import Summary from "../../../components/common/summary";
import moment from "moment";
import { asyncSearchList } from "../../../utils/httpRequests";
import { useSelector } from "react-redux";
import { numeralCustom } from "../../../utils/helpers";

type ReportType = {
  feed: {
    today: number;
    all: number;
  };
  forum: {
    today: number;
    all: number;
  };
  story: {
    today: number;
    all: number;
  };
};

function ResultToday() {
  const token = useSelector((state: any) => state.auth.token);
  const [report, setReport] = useState<ReportType>({
    feed: { today: 0, all: 0 },
    forum: { today: 0, all: 0 },
    story: { today: 0, all: 0 },
  });

  const getReport = async () => {
    const today = moment();
    const requestTodayFeed = asyncSearchList({
      apiCode: "posts",
      token,
      condition: {
        count: 1,
        q: {
          date_created: {
            $gte: today.clone().startOf("days").toISOString(),
            $lte: today.clone().endOf("days").toISOString(),
          },
        },
      },
    });
    const requestAllFeed = asyncSearchList({
      apiCode: "posts",
      token,
      condition: { count: 1 },
    });
    const requestTodayForum = asyncSearchList({
      apiCode: "forumposts",
      token,
      condition: {
        count: 1,
        q: {
          date_created: {
            $gte: today.clone().startOf("days").toISOString(),
            $lte: today.clone().endOf("days").toISOString(),
          },
        },
      },
    });
    const requestAllForum = asyncSearchList({
      apiCode: "forumposts",
      token,
      condition: { count: 1 },
    });
    const requestTodayStory = asyncSearchList({
      apiCode: "stories",
      token,
      condition: {
        count: 1,
        q: {
          date_created: {
            $gte: today.clone().startOf("days").toISOString(),
            $lte: today.clone().endOf("days").toISOString(),
          },
        },
      },
    });
    const requestAllStory = asyncSearchList({
      apiCode: "stories",
      token,
      condition: { count: 1 },
    });
    Promise.all([
      requestTodayFeed,
      requestAllFeed,
      requestTodayForum,
      requestAllForum,
      requestTodayStory,
      requestAllStory,
    ])
      .then(
        ([
          respTodayFeed,
          respAllFeed,
          respTodayForum,
          respAllForum,
          respTodayStory,
          respAllStory,
        ]) => {
          setReport({
            feed: {
              today: respTodayFeed?.data?.rows_number || 0,
              all: respAllFeed?.data?.rows_number || 0,
            },
            forum: {
              today: respTodayForum?.data?.rows_number || 0,
              all: respAllForum?.data?.rows_number || 0,
            },
            story: {
              today: respTodayStory?.data?.rows_number || 0,
              all: respAllStory?.data?.rows_number || 0,
            },
          });
        }
      )
      .catch((error) => {});
  };

  useEffect(() => {
    getReport();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box
      sx={{ p: 2, borderRadius: "10px", backgroundColor: "background.paper" }}
    >
      <Typography sx={{ fontWeight: 600, mb: 1 }}>THỐNG KÊ BÀI ĐĂNG</Typography>
      <Grid2 container spacing={2}>
        {/* Feed */}
        <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
          <Summary imageUrl="/feed.png" title="Bài feed">
            <Stack>
              <Stack direction="row" gap={1} alignItems="center">
                <Typography sx={{ color: "text.secondary" }}>
                  Hôm nay
                </Typography>
                <Typography
                  sx={{
                    fontWeight: "600",
                    color: "error.main",
                  }}
                >
                  {numeralCustom(report.feed.today).format()}
                </Typography>
              </Stack>
              <Stack direction="row" gap={1} alignItems="center">
                <Typography sx={{ color: "text.secondary" }}>Tất cả</Typography>
                <Typography
                  sx={{
                    fontWeight: "600",
                  }}
                >
                  {numeralCustom(report.feed.all).format()}
                </Typography>
              </Stack>
            </Stack>
          </Summary>
        </Grid2>
        {/* Don da ban */}
        <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
          <Summary
            imageUrl="/forum.png"
            title="Bài forum"
            wrapperSx={{
              p: 1,
              width: "100%",
              backgroundColor: "secondary.600",
              borderRadius: "10px",
              height: "100%",
            }}
          >
            <Stack>
              <Stack direction="row" gap={1} alignItems="center">
                <Typography sx={{ color: "text.secondary" }}>
                  Hôm nay
                </Typography>
                <Typography
                  sx={{
                    fontWeight: "600",
                    color: "error.main",
                  }}
                >
                  {numeralCustom(report.forum.today).format()}
                </Typography>
              </Stack>
              <Stack direction="row" gap={1} alignItems="center">
                <Typography sx={{ color: "text.secondary" }}>Tất cả</Typography>
                <Typography
                  sx={{
                    fontWeight: "600",
                  }}
                >
                  {numeralCustom(report.forum.all).format()}
                </Typography>
              </Stack>
            </Stack>
          </Summary>
        </Grid2>
        {/* Khách hàng */}
        <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
          <Summary
            imageUrl="/story.png"
            title="Story"
            wrapperSx={{
              p: 1,
              width: "100%",
              backgroundColor: "warning.100",
              borderRadius: "10px",
              height: "100%",
            }}
          >
            <Stack>
              <Stack direction="row" gap={1} alignItems="center">
                <Typography sx={{ color: "text.secondary" }}>
                  Hôm nay
                </Typography>
                <Typography
                  sx={{
                    fontWeight: "600",
                    color: "error.main",
                  }}
                >
                  {numeralCustom(report.story.today).format()}
                </Typography>
              </Stack>
              <Stack direction="row" gap={1} alignItems="center">
                <Typography sx={{ color: "text.secondary" }}>Tất cả</Typography>
                <Typography
                  sx={{
                    fontWeight: "600",
                  }}
                >
                  {numeralCustom(report.story.all).format()}
                </Typography>
              </Stack>
            </Stack>
          </Summary>
        </Grid2>
      </Grid2>
    </Box>
  );
}

export default ResultToday;
